<div class='consent-movers-modal'>

	<div class='modal-header'>

		<div class='header-left'>
			<span>Edit your selection</span>&nbsp;<span class='selection-amount'>{{ getSelectedCount() }}/{{ maxSelections }}</span>
		</div>

		<div class='header-right'>
			<mat-icon class='close' [mat-dialog-close] svgIcon='vc:close'></mat-icon>
		</div>
	</div>

	<div class='found'>
		{{ modalMovers.length }} MOVING COMPANIES FOUND
	</div>

	<app-consent-movers-list
		viewMode='full'
		[movers]='modalMovers'
		[form]='modalForm'>
	</app-consent-movers-list>

	<div class='modal-footer'>
		<button class='confirm' (click)='confirm()' [mat-dialog-close]>Confirm</button>
		<button class='cancel' (click)='cancel()' [mat-dialog-close]>Cancel</button>
	</div>

</div>
